module.exports = "<h1 class=\"welcome\">\r\n    <img src=\"assets/img/ItaniaLogo.jpg\" />\r\n</h1>"